import { authDelete } from "@api";

export const deleteToken = (
  deploymentId: string,
  tokenId: number
): Promise<string> => {
  const path = `/api/agent/deployments/${deploymentId}/tokens/${tokenId}`;
  return authDelete<string>(path);
};
